import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChronologySigner } from '../types';

const STATUS_COLUMN_WIDTH = '100px';

interface ChronologySignerItemProps {
  signer: ChronologySigner;
}

export const ChronologySignerItem: FC<ChronologySignerItemProps> = ({
  signer,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{ py: 1, px: 1.5, border: '1px solid #F8F8F9', borderRadius: '8px' }}
    >
      <Stack direction='column' gap={0.5}>
        <Typography
          sx={{ fontSize: '1.4rem', fontWeight: 500, color: '#C4C4C4' }}
        >
          {signer.label}:
        </Typography>
        <Typography
          sx={{ fontSize: '1.3rem', fontWeight: 500, color: '#0B1370' }}
        >
          {signer.name}
        </Typography>
      </Stack>

      <Stack
        direction='column'
        alignItems='flex-start'
        sx={{ minWidth: STATUS_COLUMN_WIDTH }}
      >
        <Typography
          sx={{
            fontSize: '1.3rem',
            fontWeight: 500,
            whiteSpace: 'pre-line',
            color: signer.status?.isRejected
              ? 'error.main'
              : signer.status?.isViewerTurn
                ? '#1555FC'
                : '#CCCCCC',
          }}
        >
          {signer.status
            ? signer.status.date
              ? `${signer.status.label} -`
              : signer.status.label
            : t('chronology.waiting')}
        </Typography>
        {signer.status?.date && (
          <Typography
            sx={{ fontSize: '1.3rem', fontWeight: 500, color: '#CCCCCC' }}
          >
            {signer.status.date}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
